import { hexToRgb } from "@mui/material";

export const hexToRgbValues = (hex) => {
  return hexToRgb(hex).slice(4, -1);
};
